document.addEventListener("DOMContentLoaded", function ($ = jQuery) {
	var $ = require('jquery');

	if(document.getElementById('post-category')) {
		$('select#post-category').on('select2:select', function (e) {
			var URL = e.params.data.id;

			if(URL) {
				window.location.href = URL;
			}
		});
	}
});